import { CanAccess } from '@modules/common/components/CanAccess';
import { UnifiedFieldIcon } from '@modules/common/components/UnifiedFieldIcon';
import { ManageMetadataTableRow } from '@modules/integrationsV2/types';
import { trackIntegrationPageManageMetadataEvent } from '@modules/integrationsV2/utils';
import { AddRounded, EditRounded } from '@mui/icons-material';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';

interface ManageMetadataTableActionsProps {
  onEditButtonClick: (metadata: ManageMetadataTableRow) => void;
  metadata: ManageMetadataTableRow;
  onEditUnifiedFieldButtonClick?: (metadataKey?: string) => void;
  openCreateUnifiedFieldDrawer?: (metadataKey?: string) => void;
}

export const ManageMetadataTableActions = ({
  onEditButtonClick,
  metadata,
  onEditUnifiedFieldButtonClick,
  openCreateUnifiedFieldDrawer,
}: ManageMetadataTableActionsProps) => {
  const handleUnifiedFieldClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.stopPropagation();
    if (metadata.referencedIn?.key) {
      trackIntegrationPageManageMetadataEvent({
        eventName: 'Manage Metadata Drawer - Edit Unified Field Button Clicked',
      });
      onEditUnifiedFieldButtonClick?.(metadata.referencedIn?.key);
    } else {
      trackIntegrationPageManageMetadataEvent({
        eventName:
          'Manage Metadata Drawer - Create New Unified Field Button Clicked',
      });
      openCreateUnifiedFieldDrawer?.(metadata.key);
    }
  };
  return (
    <>
      <Stack
        className="js-manage-metadata-row-action-button-group"
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        sx={{
          opacity: 0,
          position: 'absolute',
          right: 5,
          height: 'max-content',
        }}
      >
        <Tooltip
          title={
            metadata.referencedIn?.key
              ? 'Edit Unified Field'
              : 'Create Unified Field'
          }
          placement="top"
          arrow
        >
          <Box>
            <CanAccess
              resource={PermissionResource.Metadata}
              operation={PermissionOperation.Write}
            >
              <IconButton
                color="primary"
                size="small"
                sx={{ alignItems: 'center', p: 0 }}
                onClick={handleUnifiedFieldClick}
              >
                <UnifiedFieldIcon />
                {metadata.referencedIn?.key ? (
                  <EditRounded sx={{ fontSize: '12px' }} />
                ) : (
                  <AddRounded sx={{ fontSize: '12px' }} />
                )}
              </IconButton>
            </CanAccess>
          </Box>
        </Tooltip>
        <Tooltip title="Edit metadata" disableInteractive placement="top" arrow>
          <Box>
            <CanAccess
              resource={PermissionResource.Metadata}
              operation={PermissionOperation.Write}
            >
              <IconButton
                color="primary"
                size="small"
                onClick={() => onEditButtonClick(metadata)}
              >
                <EditRounded />
              </IconButton>
            </CanAccess>
          </Box>
        </Tooltip>
      </Stack>
    </>
  );
};
